<div [ngStyle]="{
  'display': 'inline-block',
  'min-width': '300px',
  'width': '100%',
  'max-height': '100%',
'overflow': 'auto'
}">
  <div class="action-container">
    <div>
      <br />
      <br />
      <nz-input-group style="min-width: 350px;" nzSearch [nzAddOnAfter]="suffixIconButton">
        <input type="text" [(ngModel)]="searchValue" nz-input (ngModelChange)="onFilterChange()"
          placeholder="search ..." />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch><nz-icon nzType="search" /></button>
      </ng-template>
    </div>

    <br />
  </div>
  <nz-table #userTable nzBordered [nzData]="listOfData" [nzLoading]="loading" [nzShowPagination]="true"
    [nzFrontPagination]="false" nzServerRender nzOuterBordered [nzPageSize]="_pageSize" [nzPageIndex]="_pageIndex"
    [nzTotal]="total" (nzPageIndexChange)="onPageIndexChange($event)" [nzTotal]="total" [nzShowTotal]="totalTemplate"
    [nzScroll]="{ x:'940px',y: tableHeight }">
    <thead>
      <tr>
        <th nzWidth="80px">No.</th>
        <th nzWidth="150px">Role Name</th>
        <th nzWidth="600px">Permissions</th>
        <th nzWidth="150px"><button *ngIf="authService.hasPermission(['role.add'])" nz-tooltip nz-button nzTooltipTitle="Add Role" nzPrimary (click)="addRole()">
            <nz-icon nzType="plus-circle" nzTheme="outline" />
          </button></th>
      </tr>
    </thead>
    <tbody>
      @for (data of listOfData; track data;let i = $index) {
      <tr>
        <td nzWidth="80px">{{i+1}}</td>
        <td nzWidth="150px">
          {{ data.name }}
        </td>
        <td nzWidth="600px">
          <ng-container *ngFor="let permission of data.permissions">
            <nz-tag [nzColor]="getTagColor(permission)">{{ permission }}</nz-tag>
          </ng-container>
        </td>
        <td nzWidth="150px">
          <button *ngIf="authService.hasPermission(['role.edit'])" nz-tooltip nz-button nzTooltipTitle="Edit Role" nzPrimary (click)="edit(data)">
            <nz-icon nzType="edit" nzTheme="twotone" />
          </button>
          <nz-divider *ngIf="authService.hasPermission(['role.edit']) && authService.hasPermission(['role.delete'])" nzType="vertical"></nz-divider>
          <button *ngIf="authService.hasPermission(['role.delete'])" nz-tooltip nz-button nzTooltipTitle="Delete Role" nzDanger nz-popconfirm
            nzPopconfirmTitle="Are you sure delete this task?" (nzOnConfirm)="confirm(data)" (nzOnCancel)="cancel()">
            <nz-icon nzType="delete" style="color: #ff4d4f;" nzTheme="fill" />
          </button>
        </td>
      </tr>
      }
    </tbody>
  </nz-table>
  <ng-template #totalTemplate let-range="range" let-total>
    Showing {{ range[0] }} - {{ range[1] }} of {{ total }} items
  </ng-template>
</div>